import LocalStorage from './localStorage';

class PersistentStorage {
    static getItem(key) {
        return LocalStorage.getItem(key);
    }

    static setItem(key, value) {
        return LocalStorage.setItem(key, value);
    }

    static removeItem(key) {
        return LocalStorage.removeItem(key);
    }
}

export default PersistentStorage;
